import { render } from "./submitState.vue?vue&type=template&id=67494123&scoped=true&ts=true"
import script from "./submitState.vue?vue&type=script&lang=ts"
export * from "./submitState.vue?vue&type=script&lang=ts"

import "./submitState.vue?vue&type=style&index=0&id=67494123&lang=less&scoped=true"

import exportComponent from "/home/npm/produce/project/yuanYaExam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67494123"]])

export default __exports__